import React from 'react';
import ReactQuill from 'react-quill';
import '../../../../system/styles/quill.snow.css';

const Editor = ({ handleChange, html, placeholder }) => {
  return (
    <ReactQuill
      theme="snow"
      onChange={handleChange}
      value={html}
      modules={Editor.modules}
      formats={Editor.formats}
      placeholder={placeholder}
    />
  );
};

Editor.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link', 'video'],
    ['clean'],
  ],
  clipboard: {
    matchVisual: false,
  },
};

Editor.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'video',
];

export default Editor;
